module.exports = "images/apple-icon-152x152.7e2c1d2276f4a8b6396ac69f81200b35.png";